<template>
  <div class="container-atb">
    <div class="header">
      <MakcLogo title="ГАРАНТИЯ"/>
      <PartnerLogo icon="atb/logo-atb"></PartnerLogo>
    </div>

    <div class="divider__top"></div>
    <div class="content">
      <section v-show="windowWidth >= 480 || mobileFormStep === 1" ref="parameters">
        <h2 class="title">Оформление</h2>
        <h3 class="subtitle">Параметры договора страхования</h3>
        <InputsContainer className="inputs-container__1" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in formData.parameters"
            class="inputs-container__field"
            :class="[0, 1, 3].includes(index) ? 'required-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
            @input="policyParametersInput($event, index)"
            @itemSelected="policyParametersSelected($event, index)"
          />
        </InputsContainer>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 2" ref="insurer">
        <div class="divider__between-blocks"></div>
        <h2 class="title">Страхователь</h2>
        <h3 class="subtitle">Персональные данные</h3>
        <InputsContainer className="inputs-container__2" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in formData.insurer"
            class="inputs-container__field"
            :class="[0, 1, 3, 4, 5, 6, 7, 8].includes(index) ? 'required-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
          />
        </InputsContainer>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 3" ref="documents">
        <div class="divider__between-blocks"></div>
        <h3 class="subtitle">Документы</h3>
        <InputsContainer className="inputs-container__3" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in formData.documents"
            class="inputs-container__field required-input"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
          />
        </InputsContainer>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 4" ref="addressReg">
        <div class="divider__between-blocks"></div>
        <h3 class="subtitle">Адрес места жительства (регистрации)</h3>
        <InputsContainer className="inputs-container__4" cols="5">
          <component :is="item.fieldType" v-for="(item, index) in formData.address"
            class="inputs-container__field"
            :class="[1, 2, 3].includes(index) ? 'required-input' : ''"
            :type="item.type"
            :items="item.items"
            v-model="item.value"
            :placeholder="item.placeholder"
            :disabled="item.disabled"
            :title="item.title"
            :maskType="item.mask"
            :error="item.error"
            @autoInput="inputEvent(item.validation, index, 'address')"
            @itemSelected="addressItemSelected($event, index, 'address')"
          />
        </InputsContainer>
      
        <Checkbox
          class="checkbox-landing"
          id="address"
          :checker="formData.checkboxes"
          icon="check-white"
        >
          <p>Адрес фактического места жительства совпадает с адресом регистрации</p>
        </Checkbox>

        <template v-if="!formData.checkboxes.address">
          <div class="divider__between-blocks"></div>
          <h3 class="subtitle" ref="addressreal">Адрес места жительства (фактический)</h3>
          <InputsContainer className="inputs-container__4" cols="5">
            <component :is="item.fieldType" v-for="(item, index) in formData.addressreal"
              class="inputs-container__field"
              :class="[1, 2, 3].includes(index) ? 'required-input' : ''"
              :type="item.type"
              :items="item.items"
              v-model="item.value"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
              :title="item.title"
              :maskType="item.mask"
              :error="item.error"
              @autoInput="inputEvent(item.validation, index, 'addressreal')"
              @itemSelected="addressItemSelected($event, index, 'addressreal')"
            />
          </InputsContainer>
        </template>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 5">
        <div class="divider__between-blocks"></div>
        <h2 class="title">Застрахованный</h2>
        <Checkbox
          class="checkbox-landing"
          id="insurerIsInsured"
          :checker="formData.checkboxes"
          icon="check-white"
          disabled
        >
          <p>Застрахованный является страхователем</p>
        </Checkbox>
  
        <div class="divider__between-blocks"></div>
        <h2 v-if="windowWidth > 480" class="title">Выгодоприобретатели на случай смерти застрахованного лица</h2>
        <h2 v-if="windowWidth <= 480" class="title">Выгодоприобретатели</h2>
        <span v-if="windowWidth <= 480" class="title__description">(на случай смерти застрахованного лица)</span>
        <Checkbox
          class="checkbox-landing"
          id="beneficiaries"
          :checker="formData.checkboxes"
          icon="check-white"
        >
          <p>Наследники Застрахованного являются Выгодоприобретателями</p>
        </Checkbox>
  
        <div v-if="!formData.checkboxes.beneficiaries" v-for="(beneficiar, index) in formData.beneficiaries" :ref="`beneficiaries-${index}`">
          <div class="divider__between-blocks"></div>
          <h3 class="subtitle">Выгодоприобретатель {{ index + 1 }}</h3>
          <InputsContainer className="inputs-container__5" cols="5">
            <component :is="item.fieldType" v-for="(item, idx) in beneficiar"
              class="inputs-container__field"
              :class="[0, 1, 3, 4, 5, 6].includes(idx) ? 'required-input' : ''"
              :type="item.type"
              :items="item.items"
              v-model="item.value"
              :placeholder="item.placeholder"
              :disabled="item.disabled"
              :title="item.title"
              :maskType="item.mask"
              :error="item.error"
              @keypress="beneficiarInput($event, index, idx)"
            />
          </InputsContainer>
        </div>

        <div v-if="!formData.checkboxes.beneficiaries" class="plus-minus">
          <span @click="addBeneficiar">+</span>
          <span @click="removeBeneficiar">-</span>
        </div>
      </section>

      <section v-show="windowWidth >= 480 || mobileFormStep === 6">
        <div class="divider__between-blocks"></div>
        <h2 class="title">Подтверждение данных</h2>
  
        <div class="shield">
          <img src="@/create/assets/icons/atb/shield-atb.svg" alt="">
          <p>Ваши данные не попадут третьим лицам. Мы соблюдаем закон о защите персональных данных</p>
        </div>
  
        <Confirmation
          class="confirmation-landing"
          checkboxClassName="checkbox-landing"
          :confirmationChecks="confirmationChecks"
          :links="links"
          :otp="false"
          icon="check-white"
        >
          Для завершения оформления договора подтвердите свои данные через безопасное соединение в Единой системе идентификации
          и аутентификации сервиса Госуслуги.<br>
          После подтверждения данных и завершения оплаты полис и комплект страховых документов будут направлены на указанный Вами адрес электронной почты.<br>
          Для подписания договора страхования простой электронной подписью необходимо ввести код из СМС, который будет
          Вам направлен на указанный номер телефона
        </Confirmation>
      </section>

      <div v-if="windowWidth >= 480 || mobileFormStep === 6" class="manager-code">
        <Input
          class="inputs-container__field"
          v-model="formData.manager_code"
          placeholder="Код продавца"
          title="Код продавца"
          maskType="passport-number"
        />
      </div>
  
      <div class="divider__between-blocks"></div>
      <div class="landing-form__steps">
        <button v-if="windowWidth <= 480"
          class="landing-form__back"
          :style="mobileFormStep === 1 ? {opacity: 0, pointerEvents: 'none'} : {}"
          @click="mobileFormStep--"
        >
          <img class="makc__logo" src="@/create/assets/icons/atb/arrow-back-atb.svg">
        </button>
        <button v-if="windowWidth <= 480 && mobileFormStep < 6"
          class="landing-form__confirm landing-form__next"
          @click="checkConfirmAndPay"
        >
          Далее
        </button>
        <button v-if="windowWidth >= 480 || mobileFormStep === 6" ref="finish"
          type="submit" class="landing-form__confirm"
          @click="creatingPaymentCheckStep === 'payment' ? cratePaymentLink() : checkConfirmAndPay()"
          :disabled="creatingPaymentCheckStatus"
        >
          {{ submitButton }}
          <img v-if="creatingPaymentCheckStatus" class="makc-alert__loading-img" src="@/create/assets/images/loading.png" alt="loading">
        </button>
      </div>

      <SMSChecker
        v-if="contractID"
        class="sms-ckecker"
        :text="SMSText"
        v-model="SMSCode"
        :disabled="SMSStatus"
        @click="SMSStep === 'get' ? SMSCodeFlow('get') : SMSCodeFlow('check')"
      >
        {{ SMSStep  === 'get' ? "Получить код" : "Проверить код" }}
        <img v-if="SMSStatus" class="makc-alert__loading-img" src="@/create/assets/images/loading.png" alt="loading">
      </SMSChecker>
    </div>
  </div>
</template>

<script>
import MakcLogo from '@/create/components/landingsConstructor/MakcLogo.vue';
import PartnerLogo from '@/create/components/landingsConstructor/PartnerLogo.vue';
import InputsContainer from '@/create/components/landingsConstructor/InputsContainer.vue';
import Input from '@/create/components/landingsConstructor/Input.vue';
import Select from '@/create/components/landingsConstructor/Select.vue';
import Autocomplete from '@/create/components/landingsConstructor/Autocomplete.vue';
import Checkbox from '@/create/components/landingsConstructor/Checkbox.vue';
import Confirmation from '@/create/components/landingsConstructor/Confirmation.vue';
import SMSChecker from '@/create/components/landingsConstructor/SMSChecker.vue';
import { defaultParameters, defaultInsurer, defaultDocuments, defaultAddress, defaultBeneficiaries } from '@/create/components/landingsConstructor/dataFields';
import { validateFields } from '@/create/components/landingsConstructor/landingValidators';
import { checkInfoFromGosuslugi, checkInfoWithGosuslugiAuth, checkSMSCode, getKidPolicyCreateContract, getKladr, getPayLink, getSMSCode } from '@/create/components/landingsConstructor/landingFunctions';
import { localDevelopment, subdomain, testDevelopment } from '@/create/composables/const';

  export default {
    components: {
      MakcLogo,
      PartnerLogo,
      InputsContainer,
      Input,
      Select,
      Autocomplete,
      Checkbox,
      Confirmation,
      SMSChecker
    },
    data() {
      return {
        formData: {
          parameters: structuredClone(defaultParameters),
          insurer: structuredClone(defaultInsurer),
          documents: structuredClone(defaultDocuments),
          address: structuredClone(defaultAddress),
          addressreal: structuredClone(defaultAddress),
          beneficiaries: [
            structuredClone(defaultBeneficiaries),
          ],
          checkboxes: {
            address: true,
            insurerIsInsured: true,
            beneficiaries: true,
          },
          manager_code: '',
        },
        confirmationChecks: {
          usa: false,
          person: false,
          nalog: false,
          politics: false,
          agreement: false,
          kid: false,
          policy: false,
        },
        links: {
          politics: 'https://makclife.ru/upload/medialibrary/2b2/PolitikaPD.pdf',
          agreement: 'https://makclife.ru/upload/medialibrary/ff8/2mo5whoofnvsxzgavmmx04ri1ua0jbdj/%D0%9F%D0%BE%D0%BB%D1%8C%D0%B7%D0%BE%D0%B2%D0%B0%D1%82%D0%B5%D0%BB%D1%8C%D1%81%D0%BA%D0%BE%D0%B5%20%D1%81%D0%BE%D0%B3%D0%BB%D0%B0%D1%88%D0%B5%D0%BD%D0%B8%D0%B5.pdf',
          kid: '',
          policy: '',
          rules: 'https://makclife.ru/b2b/life/rules/otp/rule_9_08.pdf',
        },
        
        mobileFormStep: 1,                         // это если используется пошаговая форма
        
        requestLogin: 'sysclientatb',              // логин для запросов по конкретному лендингу, устанавливается в б2б контрагентах и копируется в app.php create
        domain: localDevelopment || testDevelopment ? `https://${subdomain}.makclife.ru` : "https://makclife.ru",
        timeoutKidPolicy: null,                    // дебаунс кида
        contractID: null,
        SMSCode: '',                               // наличие смс кода
        SMSText: 'Пройдите СМС проверку',                               // текст смс подсказок
        SMSStep: 'get',                          // статус смсного этапа 
        SMSStatus: false,                          // статус смсного этапа 
        creatingPaymentCheckStep: 'gos',          // состояние кнопки формирования счета
        creatingPaymentCheckStatus: false          // дизабл кнопки формирования счета
      }
    },
    computed: {
      windowWidth() {
        return window.innerWidth
      },
      submitButton() {
        if (this.creatingPaymentCheckStep === 'gos') return 'Подтвердить данные через госуслуги'
        if (this.creatingPaymentCheckStep === 'contract') return 'Создаем договор'
        if (this.creatingPaymentCheckStep === 'payment') return 'Перейти к оплате'
      },
      structuredDataForApi() {                     // структурируем дату для передачи в контракт
        const contactsData = this.formData.checkboxes.insurerIsInsured ? structuredClone([this.formData.insurer]) : structuredClone([this.formData.insurer, this.formData.insured])
        const documentsData = this.formData.checkboxes.insurerIsInsured ? structuredClone([this.formData.documents]) : structuredClone([this.formData.documents, this.formData.documents])
        const addressData = this.formData.checkboxes.address ? structuredClone([this.formData.address, this.formData.address]) : structuredClone([this.formData.address, this.formData.addressreal])
        const beneficiariesData = this.formData.checkboxes.beneficiaries ? null : structuredClone(this.formData.beneficiaries)
        
        return {
          agreement: {
            program: 'fi',
            ins_calc_type: '0',
            ins_calc_amount: this.formData.parameters[3].value.toString(),
            ins_period: '60M',
            insured: this.formData.checkboxes.insurerIsInsured ? 0 : 1,
            insurer_sex: '0',
            named_params: {kid_signed: 'Y', landing_signer: '0', atb_tab_number: this.formData.manager_code},
          },
          contacts: contactsData,
          documents: documentsData,
          addresses: addressData,
          beneficiaries: beneficiariesData,
        }
      }
    },
    methods: {
      // ----------------- методы для обработки полей формы
      policyParametersInput(value, index) {                 // отслеживание инпутов в параметрах договора
        if (index === 0) {
          this.formData.insurer[3].value = value
        }
      },
      policyParametersSelected(item, index) {               // отслеживание селектов в параметрах договора
        if (index === 1) {
          this.formData.insurer[4].value = item
        }
      },
      async inputEvent(field, index, tag) {                 // поиск города и улицы по кладру
        if (field === 'city' && this.formData[tag][index].value.length > 1) {
          this.formData[tag][index].key = ''
          this.formData[tag][index].items = await getKladr(this.requestLogin, this.formData[tag][index].value, 'city')
        } else
        if (field === 'street' && this.formData[tag][index].value.length > 1 && this.formData[tag][index-1].key) {
          this.formData[tag][index].key = ''
          this.formData[tag][index].items = await getKladr(this.requestLogin, this.formData[tag][index].value, 'street', this.formData[tag][index-1].key)
        }
      },
      addressItemSelected(item, index, tag) {               // устанавливаем код города и улицы
        this.formData[tag][index].key = item.id
      },
      beneficiarInput(e, index, idx) {
        if (idx === 6 && (this.formData.beneficiaries[index][idx].value.length >= 2 || +this.formData.beneficiaries[index][idx].value > 99)) {
          this.formData.beneficiaries[index][idx].value = "100"
          e.preventDefault()
        }
      },
      addBeneficiar() {                                     // добавляем выгодоприобретателя 
        if (this.formData.beneficiaries.length < 5) {
          this.formData.beneficiaries.push(structuredClone(defaultBeneficiaries))
        }
      },
      removeBeneficiar() {                                  // убираем выгодоприобретателя
        if (this.formData.beneficiaries.length > 1) {
          this.formData.beneficiaries.pop()
        }
      },
      // ----------------------------------------------------- методы апи
      async watchFieldsAndGetLinksForDocuments() {          // получение ссылок на документы
        if (this.timeoutKidPolicy) {
            clearTimeout(this.timeoutKidPolicy);
        }

        this.timeoutKidPolicy = setTimeout(async () => {
          const res = await getKidPolicyCreateContract(this.requestLogin, 'get_kid', this.structuredDataForApi);
          if (res && res.state === 'success') {
            this.links.kid = this.domain + res.kid
            this.links.policy = this.domain + res.project
          }
        }, 2500);
      },
      async checkConfirmAndPay() {                          // получение ссылок на документы
        let validationResult = 0

        if (this.windowWidth <= 480 && this.mobileFormStep === 6 || this.windowWidth >= 480) {      // проверяем данные в блоках с полями
          for (const key in this.confirmationChecks) {
            if (this.confirmationChecks[key] === false) {
              validationResult++
            }
          }
        }
        if (this.windowWidth <= 480 && this.mobileFormStep === 5 || this.windowWidth >= 480) {
          if (!this.formData.checkboxes.beneficiaries) {
            let partCounter = 0
            this.formData.beneficiaries.forEach((item, index) => {
              partCounter += +item[6].value
              if (validateFields(item)) {
                this.$refs[`beneficiaries-${index}`][0].scrollIntoView();
                validationResult++
              }
            })
            if (partCounter !== 0 && partCounter !== 100) {
              this.formData.beneficiaries.forEach((item, index) => {
                item[6].error = 'сумма всех долей должна быть равна 100'
                this.$refs[`beneficiaries-${index}`][0].scrollIntoView();
                validationResult++
              })
            }
          }
        }
        if (this.windowWidth <= 480 && this.mobileFormStep === 4 || this.windowWidth >= 480) {
          if (!this.formData.checkboxes.address) {
            if (validateFields(this.formData.addressreal)) {
              this.$refs.addressreal.scrollIntoView();
              validationResult++
            }
          }
          if (validateFields(this.formData.address)) {
            this.$refs.addressReg.scrollIntoView();
            validationResult++
          }
        }
        if (this.windowWidth <= 480 && this.mobileFormStep === 3 || this.windowWidth >= 480) {
          if (validateFields(this.formData.documents, {birthDate: this.formData.parameters[0].value})) {
            this.$refs.documents.scrollIntoView();
            validationResult++
          }
        }
        if (this.windowWidth <= 480 && this.mobileFormStep === 2 || this.windowWidth >= 480) {
          if (validateFields(this.formData.insurer, {ageMax: 85})) {
            this.$refs.insurer.scrollIntoView();
            validationResult++
          }
        }
        if (this.windowWidth <= 480 && this.mobileFormStep === 1 || this.windowWidth >= 480) {
          if (validateFields(this.formData.parameters, {ageMax: 85, minPayment: 50000, maxPayment: 50000000})) {
            this.$refs.parameters.scrollIntoView();
            validationResult++
          }
        }

        if (validationResult < 1 && (this.mobileFormStep === 6 || this.windowWidth >= 480)) {   // если ни в одном блоке ошибок нет, авторизуемся на госуслугах, и редиректимся назад
          this.creatingPaymentCheckStatus = true
          await checkInfoWithGosuslugiAuth(this.requestLogin, this.formData)
          this.creatingPaymentCheckStatus = false
        }
        
        if (validationResult < 1 && this.mobileFormStep < 6) {                                  // увеличиваем шаг мобильной формы, если нет ошибок
          this.mobileFormStep++
        }
      },
      async SMSCodeFlow(tag) {
        this.SMSStatus = true
        if (tag === 'get') {
          const res = await getSMSCode(this.contractID, this.formData.insurer[7].value.match(/([0-9]|[+])/g).join(''))
          if (res.state === 'success' && res.id) this.SMSStep = 'check'
        }
        if (tag === 'check') {
          const res = await checkSMSCode(this.contractID, this.SMSCode)
          if (res.state === 'success') {
            this.creatingPaymentCheckStep = 'payment'
            this.SMSText = 'Проверка пройдена'
          } else this.SMSText = 'Не верный код'
        }
        this.SMSStatus = false
      },
      async cratePaymentLink() {                                                            // создаем ссылку на оплату после проверок госуслуг и смс кода
        this.creatingPaymentCheckStatus = true
        const data = {
          contractId: this.contractID,
          phone: this.formData.insurer[7].value.match(/([0-9]|[+])/g).join(''),
          email: this.formData.insurer[8].value
        }
        await getPayLink(this.requestLogin, data)       
        this.creatingPaymentCheckStatus = false
      }
    },
    
    async mounted() {
      window.document.head.getElementsByTagName('title')[0].innerHTML = 'Гарантия'          // тайтл страницы

      const result = await checkInfoFromGosuslugi(this.requestLogin)                        // чекаем инфу с госуслуг
      if (result && result.state === 'success' && result.data) {
        this.formData = result.data                                                         // все поля объекта для передачи должны быть с маленькими буквами, госуслуги их потом так возвращает
      }
      if (result && result.error_coincidence && Object.entries(result.error_coincidence).length) {        // выводим ошибки
        for (let key in result.error_coincidence) {
          if (this.formData.documents.find(i => i.fieldName === key)) {
            this.formData.documents.find(i => i.fieldName === key).error = 'данные на портале госуслуг не совпадают'
            this.mobileFormStep = 3
          }
          if (this.formData.insurer.find(i => i.validation === key)) {
            this.formData.insurer.find(i => i.validation === key).error = 'данные на портале госуслуг не совпадают'
            setTimeout(() => {
              this.mobileFormStep = 2
            }, 0);
          }
        }
        setTimeout(() => {
          if (this.windowWidth >= 480) this.$refs.insurer.scrollIntoView();
        }, 150)
      } else if (result) {                                                                  // если инфа ок, то создаем контракт
        this.creatingPaymentCheckStatus = true
        this.creatingPaymentCheckStep = 'contract'
        for (const key in this.confirmationChecks) {
          this.confirmationChecks[key] = true
        }
        this.mobileFormStep = 6
        setTimeout(() => {
          this.$refs.finish.scrollIntoView();
        }, 150)
        const res = await getKidPolicyCreateContract(this.requestLogin, 'create', this.structuredDataForApi);
        if (res && res.state === 'success') {
          this.contractID = res.id
          setTimeout(() => {
            window.scrollTo(0, 2500)
          }, 50)
          
        }
        this.creatingPaymentCheckStatus = false
      }

      this.$watch(vm => [vm.formData], () => {          // отслеживаем форму и производим калькуляцию
        this.watchFieldsAndGetLinksForDocuments()
      }, {
        immediate: true,
        deep: true
      })
    }
  }
</script>

<style lang="scss" scoped>
// -------------------- шрифты для этого лендинга

@font-face {
	font-family: 'Circe';
	src: url('@/create/assets/fonts/circe/circe.woff2') format('woff2'), /* Super Modern Browsers */
}

// -------------------- стили этого лендинга
.container-atb {                    // десктоп контейнер
  max-width: 1320px;
  margin: 0 auto;
  width: calc(100vw - 40px);
  font-family: Circe;
}

.divider {                          // разделители между разными блоками и подблоками
  &__top {
    margin-top: 120px;
  }

  &__between-blocks {
    margin-top: 70px;
  }
}

.header {                           // шапка с логотипами
  margin-top: 60px;
  display: flex;
  justify-content: space-between;

  :deep(.makc__block) {
    position: relative;
    margin-left: 16px;
    top: 6px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  
  :deep(.makc__title) {
     font-weight: 700;
     font-size: 30px;
     color: #555854;
     width: max-content;
  }

  :deep(.makc__subtitle) {
    font-weight: 400;
    font-size: 24px;
    color: #555854;
    margin: 0;
   }
}

.title {                            // заголовок большой (Оформление, Страхователь, Застрахованный...)
  font-weight: 700;
  font-size: 34px;
  line-height: normal;
  color: #555854;
}

.subtitle {                         // подзаголовок (Параметры договора страхования, Персональные данные, Документы)
  margin-top: 4px;
  font-weight: 400;
  font-size: 22px;
  line-height: normal;
  color: #555854;
}

.inputs-container {                 // грид контейнер - здесь расположение, отступы вложенных элементов
  &__1 {                            // 1 контейнер с параметрами
    margin-top: 40px;
    gap: 20px;
  }

  &__2 {                            // 2 контейнер с персональными данными
    margin-top: 40px;
    gap: 20px;

    .inputs-container__field:nth-child(4),
    .inputs-container__field:nth-child(5) {
      display: none;
    }

    .inputs-container__field:nth-child(9) {
      grid-column: span 2;
    }
  }

  &__3 {                            // 3 контейнер с документами
    margin-top: 30px;
    gap: 20px;

    .inputs-container__field:nth-child(6) {
      grid-column: span 3;
    }
  }

  &__4 {                            // 4 контейнер с адресом
    margin-top: 30px;
    gap: 20px;
  }

  &__5 {                            // 5 контейнер с выгодоприобретателями
    margin-top: 30px;
    gap: 20px;

    .inputs-container__field:nth-child(6) {
      grid-column: span 3;
    }
  }

  &__field {                        // верстка каждого инпута и его содержимого
    :deep(p) {                      // метка над инпутом
      font-weight: 400;
      font-size: 15px;
      color: #6E6E6E;
      margin-bottom: 6px;
    }

    :deep(input),                   // внешний вид инпутов
    :deep(select) {
      border: 1px solid #E3E3E3;
      border-radius: 10px;
      padding: 10px 20px;
      max-height: 52px;
      font-weight: 400;
      font-size: 1rem;
      line-height: 31px;
      color: #6E6E6E;
      outline: none;
      font-family: Circe;

      &::placeholder {
        color: #C8C8C8;
      }
    }

    :deep(select) {                 // внешний вид селектов
      background: url('@/create/assets/icons/atb/arrow-down-atb.svg') no-repeat 92% 50%;
      color: #C8C8C8;
    }
    
    :deep(select:valid) {
      color: #6E6E6E;
    }

    :deep(option) {                 // внешний вид опций селекта
      color: #6E6E6E;
    }

    :deep(.autocomplete__items) {   // внешний вид автокомплита для адресов
      background-color: white;
      max-height: 115px;

      div {
        color: #6E6E6E;
        padding-left: 4px;

        &:hover {
          background-color: black;
          color: white;
        }
      }
    }

    :deep(span) {                   // ошибки валидации под инпутами 
      margin-top: 8px;
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      color: #D72626;
    }
  }
}

.required-input {                   // звездочки над обязательными полями
  :deep(p::before) {
    content: '*';
    position: relative;
    color: #D72626;
  }
}

.checkbox-landing {                 // чекбоксы (адрес, наследники...)
  margin-top: 20px;

  :deep(label) {
    gap: 8px;
  }

  :deep(span) {
    width: 20px;
    height: 20px;
    padding: 4px;
    border-radius: 5px;
    border: 1px solid #FE5000;
  }

  :deep(input:checked + label > span) {
    background-color: #FE5000;
  }
  
  :deep(p) {
    font-weight: 400;
    font-size: 15px;
    color: #6E6E6E;
  }

  :deep(input:disabled + label > span) {
    background-color: #6E6E6E;
    border-color: #6E6E6E;
  }
}

.plus-minus {                       // кнопки добавить, удалить выгодоприобретателя
  margin-top: 20px;
  display: flex;
  gap: 10px;

  span {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #E3E3E3;
    border-radius: 50%;
    font-size: 1.5rem;
    cursor: pointer;
  }
}

.shield {                           // титул блока о защите данных
  margin-top: 30px;
  width: max-content;
  display: flex;
  gap: 10px;
  align-items: center;
  border: 1px solid #14BB33;
  border-radius: 50px;
  padding: 13px 28px;

  p {
    font-weight: 400;
    font-size: 16px;
    color: #14BB33;
  }

}

.confirmation-landing {             // блок с подтверждениями, согласием и документами
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  gap: 10px;

  :deep(p) {
    font-weight: 400;
    font-size: 15px;
    color: #6E6E6E;
  }

  :deep(>p:not(:last-child)) {
    margin-left: 30px;
  }

  :deep(a) {
    color: #2F5ADA;
    text-decoration: none;
  }

  :deep(.checkbox-landing) {        // чекбоксы (кид, полис, правила...)
    label {
      gap: 8px;
    }

    span {
      width: 20px;
      height: 20px;
      padding: 4px;
      border-radius: 5px;
      border: 1px solid #FE5000;
    }

    input:checked + label > span {
      background-color: #FE5000;
    }
    
    input:disabled + label > span {
      background-color: #6E6E6E;
      border-color: #6E6E6E;
    }
  }
}

.manager-code {
  margin-top: 30px;
  display: flex;
}

.landing-form {
  &__steps {
    margin-bottom: 20px;
  }
  
  &__confirm {            // кнопка подтвердить данные и перейти к оплате
    border-radius: 50px;
    border: none;
    padding: 0 36px;
    height: 54px;
    background-color: #FE5000;
    font-weight: 500;
    font-size: 1rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      margin-left: 10px;
      max-height: 50%;
    }
  }
}

.sms-ckecker {
  :deep(div) {
    gap: 14px;
    display: flex;
    margin-bottom: 20px;
  }

  :deep(p) {
    font-weight: 400;
    font-size: 15px;
    color: #6E6E6E;
  }

  :deep(input) {
    width: 96px;
    padding: 8px 10px;
    border: 1px solid #FE5000;
    border-radius: 50px;
  }

  :deep(button) {
    border-radius: 50px;
    padding: 0 10px;
    outline: none;
    border: none;
    background-color: #FE5000;
    font-weight: 500;
    font-size: 1rem;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    img {
      margin-left: 10px;
      width: 18px;
    }
  }
}


// ------------------------ мобильная верстка ------------------------

@media (max-width: 480px) {
  .divider {                          // разделители между разными блоками и подблоками
    &__top {
      margin-top: 40px;
    }

    &__between-blocks {
      margin-top: 40px;
    }
  }

  .header {                           // шапка с логотипами
    margin-top: 40px;
    width: max-content;
    flex-direction: column-reverse;
    gap: 12px;
    
    :deep(.makc__logo) {
      width: 31px;
    }
    
    :deep(.makc__block) {
      margin-left: 10px;
      top: 0;
      gap: 2px;
    }

    :deep(.makc__title) {
      font-size: 16px;
    }

    :deep(.makc__subtitle) {
      font-size: 12px;
    }

    :deep(.partner__logo) {
      width: 142px;
    }
  }

  .title {                            // заголовок большой (Оформление, Страхователь, Застрахованный...)
    font-size: 24px;

    &__description {
      font-size: 4.7vw;
    }
  }

  .subtitle {                         // подзаголовок (Параметры договора страхования, Персональные данные, Документы)
    font-size: 16px;
  }

  .inputs-container {                 // грид контейнер - здесь расположение, отступы вложенных элементов
    &__1 {                            // 1 контейнер с параметрами
      margin-top: 30px;

      .inputs-container__field:nth-child(-n+5) {
        grid-column: span 5;
      }
    }

    &__2 {                            // 2 контейнер с персональными данными
      margin-top: 30px;
      
      .inputs-container__field:nth-child(-n+9) {
        grid-column: span 5;
      }
    }

    &__3 {                            // 3 контейнер с документами
      .inputs-container__field:nth-child(-n+6) {
        grid-column: span 5;
      }
    }

    &__4 {                            // 4 контейнер с адресом
      .inputs-container__field:nth-child(-n+7) {
        grid-column: span 5;
      }
    }

    &__5 {                            // 5 контейнер с выгодоприобретателями

      .inputs-container__field:nth-child(-n+7) {
        grid-column: span 5;
      }
    }

    &__field {                        // верстка каждого инпута и его содержимого
      :deep(p) {                      // метка над инпутом
        font-size: 13px;
      }

      :deep(input),                   // внешний вид инпутов
      :deep(select) {
        border-radius: 6px;
        padding: 12px 14px;
        max-height: 44px;
        font-size: 14px;
        line-height: 16px;
      }

      :deep(select) {                 // внешний вид селектов
        background: url('@/create/assets/icons/atb/arrow-down-atb.svg') no-repeat 95% 50%;
      }

      :deep(span) {                   // ошибки валидации под инпутами 
        font-size: 12px;
        line-height: 14px;
      }
    }
  }

  .checkbox-landing {                 // чекбоксы (адрес, наследники...)
    :deep(label) {
      gap: 10px;
    }

    :deep(span) {
      align-self: start;
      min-width: 20px;
    }
    
    :deep(p) {
      font-size: 12px;
      line-height: 14px;
    }
  }

  .shield {                           // титул блока о защите данных
    width: auto;
    padding: 14px;

    p {
      font-size: 12px;
      line-height: 14px;
    }

  }

  .confirmation-landing {             // блок с подтверждениями, согласием и документами
    gap: 10px;

    :deep(p) {
      font-size: 12px;
      line-height: 14px;
    }

    :deep(>p:not(:last-child)) {
      margin-left: 30px;
    }

    :deep(.checkbox-landing) {        // чекбоксы (кид, полис, правила...)
      span {
        min-width: 20px;
        align-self: start;
      }
    }
  }

  .manager-code {
    display: block;
  }

  .landing-form {
    &__steps {
      display: flex;
      justify-content: space-between;
      gap: 10px;
    }

    &__back {
      padding: 12px 26px;
      font-weight: 500;
      border-radius: 50px;
      border: none;
      background-color: #C8C8C8;
      cursor: pointer;
    }

    &__next {
      width: 146px;
    }
    
    &__confirm {             // кнопка подтвердить данные и перейти к оплате
      font-weight: 400;
      font-size: 12px;
      line-height: 18px;
      padding: 0 20px;
      max-width: calc(100% - 80px);
    }
  }
}
</style>